// extracted by mini-css-extract-plugin
module.exports = {"bookmarks":"BookmarkGroup_bookmarks__3-uCP"};